<template>
  <CRow>
    <CCol sm="12">

      <CCard>

        <CCardHeader>
          <CIcon name="cil-text"/>
          Katalogmaterial ändern
        </CCardHeader>

        <CCardBody>
          <ValidationObserver v-slot="{ invalid }">
            <CForm class="no-mb" @submit.prevent="updateMaterial()">
              <MaterialText v-model="material" formLabel="Materialname"/>
              <MaterialText v-model="artikelnr" formLabel="Artikelnummer" rules=""/>
              <MaterialText v-model="herstellernummer" formLabel="Herstellernummer" rules=""/>
              <MaterialText v-model="hersteller" formLabel="Hersteller" rules=""/>
              <MaterialText v-model="stueck" formLabel="Standardmenge"/>
              <MaterialText v-model="qtySuggestionsText" formLabel="Stückvorschläge" rules="" placeholder="z. B. 1, 2, 3, 5, 10" />

              <MaterialText
                v-model="recentQtySuggestionsText"
                formLabel="Zuletzt verwendet"
                rules=""
                disabled="disabled"
                placeholder="Wird täglich aus Protokollen berechnet"
              />
              <small class="text-muted d-block mb-3">
                Diese Werte werden täglich aus den zuletzt verwendeten Protokollmengen berechnet und können hier nicht geändert werden.
              </small>

              <div v-if="qtySuggestionPreview.length > 0" class="qty-preview mb-3">
                <CButton
                  v-for="qty in qtySuggestionPreview"
                  :key="`qty-preview-${uuid}-${qty}`"
                  color="secondary"
                  variant="outline"
                  size="sm"
                  class="mr-1 mb-1"
                  disabled
                >
                  {{ formatQuantitySuggestionLabel(qty) }}
                </CButton>
              </div>

              <FormError v-if="formError" :errormessage="formError"/>

              <CRow class="mt-4">
                <CCol col="12" class="text-right">
                  <CButton color="primary" class="px-4" :disabled="invalid" type="submit">Material ändern</CButton>
                </CCol>
              </CRow>

            </CForm>
          </ValidationObserver>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import FormError from '@/components/FormError'
import MaterialText from '@/components/FormElements/Text'

export default {
  name: 'MaterialEdit',
  components: {
    FormError,
    MaterialText
  },
  props: {
    uuid: [Number, String]
  },
  data () {
    return {
      material: '',
      artikelnr: '',
      herstellernummer: '',
      hersteller: '',
      stueck: '1',
      qtySuggestionsText: '',
      recentQtySuggestionsText: '',
      formError: null
    }
  },
  computed: {
    qtySuggestionPreview () {
      return this.normalizeSuggestions(this.qtySuggestionsText)
    }
  },
  mounted () {
    if (this.uuid) {
      Vue.axios.get('/material/catalog/' + this.uuid)
        .then((response) => {
          this.material = response.data.material || ''
          this.artikelnr = response.data.artikelnr || ''
          this.herstellernummer = response.data.herstellernummer || ''
          this.hersteller = response.data.hersteller || ''
          this.stueck = response.data.stueck || '1'
          this.qtySuggestionsText = Array.isArray(response.data.qtysuggestions) ? response.data.qtysuggestions.join(', ') : ''
          this.recentQtySuggestionsText = Array.isArray(response.data.recentqtysuggestions) ? response.data.recentqtysuggestions.join(', ') : ''
        })
    }
  },
  methods: {
    updateMaterial () {
      Vue.axios.put('/material/put/' + this.uuid, {
        material: this.material,
        artikelnr: this.artikelnr,
        herstellernummer: this.herstellernummer,
        hersteller: this.hersteller,
        stueck: this.stueck,
        qtysuggestions: this.qtySuggestionsText
      }).then((response) => {
        this.$router.push({ path: '/material/uebersicht' })
        this.$snotify.success('Das Katalogmaterial wurde angepasst.', {
          position: 'rightTop',
          timeout: 4000
        })
      }).catch((error) => {
        this.formError = error.response.data
      })
    },
    normalizeSuggestions (value) {
      return value
        .split(/[\n,;]+/)
        .map(item => item.trim())
        .filter(item => item !== '')
    },
    formatQuantitySuggestionLabel (quantity) {
      const normalizedQuantity = String(quantity || '').trim()
      return /^[-+]?\d+(?:[.,]\d+)?$/.test(normalizedQuantity) ? `${normalizedQuantity}x` : normalizedQuantity
    }
  }
}
</script>
